import React from 'react';
import axios from 'Axios';

export default function withSpecSheet(Component) {
  return class WrapperComponent extends React.Component {
    state = {
      luminaireType: {
        name: 'Luminaire Type',
        options: '',
        criteriaIdForBe: 99999,
        criteriaStringForBe: '',
        unit: '',
      },

      mountingPosition: {
        name: 'Mounting Position',
        options: '',
        criteriaIdForBe: 99999,
        criteriaStringForBe: '',
        unit: '',
      },

      manufacturer: {
        name: 'Manufacturer',
        options: '',
        criteriaIdForBe: 99999,
        criteriaStringForBe: '',
        unit: '',
      },

      productRange: {
        name: 'Product Range',
        options: '',
        criteriaIdForBe: 99999,
        criteriaStringForBe: '',
        unit: '',
      },

      mounting: {
        name: 'Mounting',
        options: [],
        criteriaIdForBe: 99999,
        criteriaStringForBe: '',
        unit: '',
      },

      finish: {
        name: 'Finish',
        options: [],
        criteriaIdForBe: 99999,
        criteriaStringForBe: '',
      },

      accessories: {
        name: 'Accessories',
        options: [],
        criteriaIdForBe: [99999],
        criteriaStringForBe: '',
        unit: '',
      },

      protectionRating: {
        name: 'Protection Rating',
        options: [],
        criteriaIdForBe: 99999,
        criteriaStringForBe: '',
        unit: '',
      },

      protectionRatingIk: {
        name: 'IK',
        options: '',
        criteriaIdForBe: 99999,
        criteriaStringForBe: '',
        unit: '',
      },

      opticalDistribution: {
        name: 'Optical Distribution',
        options: '',
        criteriaIdForBe: 99999,
        criteriaStringForBe: '',
        unit: 'º',
      },

      luminaireLifetime: {
        name: 'Luminaire Lifetime',
        options: '',
        criteriaIdForBe: 99999,
        criteriaStringForBe: '',
        unit: 'hrs',
      },

      l: {
        name: 'L',
        options: '',
        criteriaIdForBe: 99999,
        criteriaStringForBe: '',
        unit: '',
      },

      b: {
        name: 'B',
        options: '',
        criteriaIdForBe: 99999,
        criteriaStringForBe: '',
        unit: '',
      },

      lightSourceType: {
        name: 'Light Source Type',
        options: [],
        criteriaIdForBe: 99999,
        criteriaStringForBe: '',
        unit: '',
      },

      lightSourceColour: {
        name: 'Light Source Colour',
        unit: '',
        options: [],
        criteriaIdForBe: 99999,
        criteriaStringForBe: '',
        unit: '',
      },

      colourRendering: {
        name: 'Colour Rendering',
        options: '',
        criteriaIdForBe: 99999,
        criteriaStringForBe: '',
        unit: '',
      },

      maxColourVariation: {
        name: 'Max Colour Variation',
        options: [],
        criteriaIdForBe: 99999,
        criteriaStringForBe: '',
      },

      ratedLuminousFlux: {
        name: 'Rated Luminous Flux',
        options: '',
        criteriaIdForBe: 99999,
        criteriaStringForBe: '',
        unit: 'lm',
      },

      inputPower: {
        name: 'Input Power',
        options: '',
        criteriaIdForBe: 99999,
        criteriaStringForBe: '',
        unit: 'W',
      },

      efficacy: {
        name: 'Efficacy',
        options: '',
        criteriaIdForBe: 99999,
        criteriaStringForBe: '',
        // this.state.ratedLuminousFlux.value / this.state.inputPower.value,
        disabled: true,
        unit: '',
      },

      driverLocation: {
        name: 'Driver Location',
        options: [],
        criteriaIdForBe: 99999,
        criteriaStringForBe: '',
        unit: '',
      },

      dimmable: {
        name: 'Dimmable',
        options: [],
        criteriaIdForBe: 99999,
        criteriaStringForBe: '',
        unit: '',
      },

      dimmingType: {
        name: 'Dimming Type',
        options: [],
        criteriaIdForBe: 99999,
        criteriaStringForBe: '',
        unit: '',
      },

      emergencyLighting: {
        name: 'Emergency Lighting',
        options: [],
        criteriaIdForBe: 99999,
        criteriaStringForBe: '',
        unit: '',
      },

      emergencyType: {
        name: 'Emergency Type',
        options: [],
        criteriaIdForBe: 99999,
        criteriaStringForBe: '',
        unit: '',
      },
    };

    componentDidMount() {
      this.getInternalCriteria();
    }

    getInternalCriteria = () => {
      axios
        .get('/criteria/internal')
        .then(response => {
          if (response.status === 200) {
            this.setCriteriaForRendering(
              response.data.secondLayerCriteria,
              false
            );
          }
        })
        .catch(err => {
          if (err.response) {
            this.setState({
              error: err.response.data.message,
              showError: true,
            });
          }
        });
    };

    setCriteriaForRendering = criteriaResponse => {
      let obj = {};
      Object.keys(this.state).forEach(key => {
        obj[key] = JSON.parse(JSON.stringify(this.state[key]));
      });
      // give them options and IDs
      criteriaResponse.forEach(item => {
        if (item.id === 16) {
          obj.mounting.id = item.id;
          obj.mounting.options = item.thirdLayerCriteria;
        }
        if (item.id === 8) {
          obj.luminaireType.id = item.id;
          obj.luminaireType.options = item.thirdLayerCriteria;
        }
        if (item.id === 15) {
          obj.mountingPosition.id = item.id;
          obj.mountingPosition.options = item.thirdLayerCriteria;
        }
        if (item.id === 10) {
          obj.finish.id = item.id;
          obj.finish.options = item.thirdLayerCriteria;
        }
        if (
          item.id === 47 ||
          item.id === 48 ||
          item.id === 49 ||
          item.id === 46 ||
          item.id === 543
        ) {
          obj.accessories.id = item.parentId;
          obj.accessories.options = [
            ...obj.accessories.options,
            item.thirdLayerCriteria,
          ];
        }
        if (item.id === 38) {
          obj.protectionRating.id = item.id;
          obj.protectionRating.options = item.thirdLayerCriteria;
        }
        if (item.id === 18) {
          obj.opticalDistribution.id = item.id;
          obj.opticalDistribution.options = item.thirdLayerCriteria;
        }
        if (item.id === 326) {
          obj.luminaireLifetime.id = item.id;
        }
        if (item.id === 327) {
          obj.l.id = item.id;
        }
        if (item.id === 328) {
          obj.b.id = item.id;
        }
        if (item.id === 26) {
          obj.lightSourceType.id = item.id;
          obj.lightSourceType.options = item.thirdLayerCriteria;
        }
        if (item.id === 23) {
          obj.lightSourceColour.id = item.id;
          obj.lightSourceColour.options = item.thirdLayerCriteria;
        }
        if (item.id === 21) {
          obj.colourRendering.id = item.id;
          // obj.colourRendering.options = item.thirdLayerCriteria;
        }
        if (item.id === 24) {
          obj.maxColourVariation.id = item.id;
          obj.maxColourVariation.options = item.thirdLayerCriteria;
        }
        if (item.id === 33) {
          obj.ratedLuminousFlux.id = 325;
        }
        if (item.id === 32) {
          obj.inputPower.id = 324;
        }
        if (item.id === 36) {
          obj.driverLocation.id = item.id;
          obj.driverLocation.options = item.thirdLayerCriteria;
        }
        if (item.id === 263) {
          obj.dimmable.id = item.id;
          obj.dimmable.options = item.thirdLayerCriteria;
        }
        if (item.id === 44) {
          obj.dimmingType.id = item.id;
          obj.dimmingType.options = item.thirdLayerCriteria;
        }
        if (item.id === 369) {
          obj.emergencyLighting.id = item.id;
          obj.emergencyLighting.options = item.thirdLayerCriteria;
        }
        if (item.id === 372) {
          obj.emergencyType.id = item.id;
          obj.emergencyType.options = item.thirdLayerCriteria;
        }
        if (item.id === 39) {
          obj.protectionRatingIk.id = item.id;
          obj.protectionRatingIk.options = item.thirdLayerCriteria;
        }
      });

      this.setState({ ...obj });
    };

    setInitialSpecSheet = (initialData, manufacturer) => {
      const initialObj = {};
      Object.keys(this.state).forEach(key => {
        initialObj[key] = JSON.parse(JSON.stringify(this.state[key]));
        if (key === 'manufacturer' || key === 'efficacy') {
          return;
        } else if (key === 'protectionRating') {
          if (initialData[key]) {
            initialObj[key].criteriaIdForBe =
              initialData[key].criteriaId === 382
                ? Number(initialData[key].criteriaId)
                : Number(initialData[key].criteriaId) || 99999;
            initialObj[key].criteriaStringForBe = initialData[key].value || '';
          } else {
            initialObj[key].criteriaIdForBe = 99999;
            initialObj[key].criteriaStringForBe = '';
          }
        } else if (key === 'accessories') {
          if (initialData[key]) {
            initialObj[key].criteriaIdForBe =
              initialData[key].map(item => ({
                value: item.criteriaId,
                label: item.criteriaName,
              })) || [];
            initialObj[key].criteriaStringForBe =
              initialData[key]
                .map(item => item.value)
                .filter(string => string !== null && string !== '')[0] || '';
          } else {
            initialObj[key].criteriaIdForBe = 99999;
            initialObj[key].criteriaStringForBe = '';
          }
        } else if (key === 'productRange') {
          if (initialData[key]) {
            initialObj[key].criteriaStringForBe = initialData[key] || '';
          } else {
            initialObj[key].criteriaIdForBe = 99999;
            initialObj[key].criteriaStringForBe = '';
          }
        } else {
          if (initialData[key]) {
            initialObj[key].criteriaIdForBe =
              initialData[key].criteriaId || 99999;
            initialObj[key].criteriaStringForBe = initialData[key].value || '';
            if (initialData[key].unit)
              initialObj[key].unit = initialData[key].unit;
          } else {
            initialObj[key].criteriaIdForBe = 99999;
            initialObj[key].criteriaStringForBe = '';
          }
        }
      });

      if (initialData.ratedLuminousFlux && initialData.inputPower) {
        initialObj.efficacy.criteriaStringForBe = 'equation';
        if (
          initialData.ratedLuminousFlux.value &&
          initialData.inputPower.value
        ) {
          initialObj.efficacy.criteriaStringForBe =
            Number(initialData.ratedLuminousFlux.value) /
              Number(initialData.inputPower.value) +
            ' lm/W';
        }
      }

      initialObj.manufacturer.criteriaStringForBe = manufacturer;
      this.setState({ ...initialObj });
    };

    handleSelectChange = (name, options, id, criteria) => option => {
      let _option = [];
      if (id === 7) {
        if (
          option.map(item => item.value).includes(550) &&
          option.map(item => item.value).includes(551)
        ) {
          criteria.criteriaStringForBe = '';
        }
        if (option.length > 0) {
          _option = option.filter(opt => opt.value !== 99999);
          this.setState(prevState => ({
            [name]: {
              ...prevState[name],
              criteriaIdForBe:
                name !== 'colourRendering'
                  ? option.value === 318
                    ? ''
                    : option.map(opt => opt)
                  : '',
              criteriaStringForBe: criteria.criteriaStringForBe
                ? criteria.criteriaStringForBe
                : '',
            },
          }));
        } else {
          this.setState(prevState => ({
            [name]: {
              ...prevState[name],
              criteriaIdForBe: 9999,
              criteriaStringForBe: option,
            },
          }));
        }
      } else if (id === 324 || id === 325) {
        this.setState(prevState => ({
          [name]: {
            ...prevState[name],
            unit: option.value,
          },
        }));
      } else {
        this.setState(prevState => ({
          [name]: {
            ...prevState[name],
            criteriaIdForBe: option.value,
            criteriaStringForBe:
              name === 'colourRendering'
                ? option.value === 318
                  ? ''
                  : option.label
                : '',
          },
        }));
      }
    };

    handleInputChange = (name, rangeValue) => event => {
      event.persist();
      if (name === 'lightSourceColourRange') {
        this.setState(prevState => ({
          lightSourceColour: {
            ...prevState.lightSourceColour,
            criteriaStringForBe: rangeValue,
          },
        }));
      } else {
        this.setState(prevState => ({
          [name]: {
            ...prevState[name],
            criteriaStringForBe: event.target.value,
          },
        }));
      }
    };

    render() {
      return (
        <Component
          {...this.props}
          specificationSheet={this.state}
          setInitialSpecSheet={this.setInitialSpecSheet}
          handleSelectChange={this.handleSelectChange}
          handleInputChange={this.handleInputChange}
        />
      );
    }
  };
}
